<div [ngClass]="{'mb-3': label.length > 0}">
    @if (label.length > 0) {
        <label class="form-label" [class]="required ? 'required' : ''" [for]="id">
            {{ label }}
        </label>
    }

    <div [formGroup]="formGroup">
        <div formArrayName="formArray">
            @for (item of formGroup.controls.formArray.controls; track $index) {
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="id + '-' + $index"
                        [formControl]="item.controls.selected" />
                    <label [for]="id + '-' + $index" [title]="item.value.hint ?? ''">
                        {{ item.value.name }}
                    </label>
                </div>
            }
        </div>
    </div>
    @if (ngControl.control) {
        @if (formGroup.controls.formArray.controls.length === 0) {
            <div class="form-text">
                {{
                    'control-messages_NOTHING_TO_SELECT'
                        | translate: 'common' : 'brunata-angular-ui'
                }}
            </div>
        }
        <app-control-messages [control]="ngControl.control" />
    }
</div>
